import {
  IndicatorLabel,
  SparkleIcon,
  Tooltip,
  TooltipContent,
} from "@codat/orchard-ui";
import { useState } from "react";

import styles from "./ManageLogin.module.css";

export const PremiumIcon = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Tooltip
      data-testid="premium-tooltip"
      id="tooltip"
      isOpen={isOpen}
      placement="left"
      content={
        <TooltipContent title={<strong>This is a premium feature</strong>}>
          You do not have access to this feature. Unlock this feature by
          upgrading.
        </TooltipContent>
      }
    >
      <div
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        <IndicatorLabel
          className={styles.premiumLabel}
          label="Premium"
          leftIcon={<SparkleIcon />}
          data-testid="premium-label"
        />
      </div>
    </Tooltip>
  );
};
